import {
  DEFAULT_BILLING_INTERVAL,
  resolveOpenInterval,
  type BillingInterval,
  type OpenBillingModalOptions,
  type PreselectedPlan,
} from '~/utils/billing/billingModalInterval';

export const useBillingModal = () => {
  const open = useState('billingModal:open', () => false);
  const initialInterval = useState<BillingInterval>('billingModal:interval', () => DEFAULT_BILLING_INTERVAL);
  // When set, the modal jumps straight to checkout for this plan (used by the
  // admin-generated `?upgrade=` deep-link). Null → normal plan-picker entry.
  const initialPlan = useState<PreselectedPlan | null>('billingModal:plan', () => null);

  const uaeGate = useUaeGate();
  const tourActive = useProductTourActive();

  const openModal = (opts?: OpenBillingModalOptions) => {
    // Nothing interrupts the product tour; the end-of-tour rule decides what follows it.
    if (tourActive.value) return;
    // UAE agents never see plans: every upgrade entry point opens their next-step sheet instead.
    if (uaeGate.isUae.value) {
      uaeGate.openGate({ trigger: 'locked_action', nextStep: null, action: 'upgrade' });
      return;
    }
    initialPlan.value = opts?.plan ?? null;
    // Reset per open so a previous Annual open never sticks.
    initialInterval.value = resolveOpenInterval(opts);
    open.value = true;
  };

  const close = () => {
    open.value = false;
  };

  return {
    open: readonly(open),
    initialInterval: readonly(initialInterval),
    initialPlan: readonly(initialPlan),
    openModal,
    close,
  };
};
